const URL = 'https://eshop-be-1418.herokuapp.com';
// const URL = 'http://localhost:3001';
export default URL;
